import { FC, useEffect } from "react";

const Error: FC = () => {
    useEffect(() => {
        window.location.href = "/"
    }, [])
    return <div></div>
}
export default Error